import { render, staticRenderFns } from "./SdiUser.vue?vue&type=template&id=97455622"
import script from "./SdiUser.vue?vue&type=script&lang=js"
export * from "./SdiUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports